import React, { useState } from "react";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import { PlayCircleOutline } from "@material-ui/icons";
import styles from "../styles";
import { ModalVideo } from "../ModalVideo";

export const GridVideo = () => {
  const classes = styles();
  const [open, setOpen] = useState(false);
  const [dataVideo, setDataVideo] = useState({
    title: "",
    url: ""
  });

  const handleCloseModal = () => {
    setOpen(false);
  };
  const handleOpenModal = (title, url) => {
    setDataVideo({
      title,
      url
    });
    setOpen(true);
  };
  return (
    <div className={classes.root}>
      <ModalVideo
        open={open}
        handleClose={handleCloseModal}
        url={dataVideo.url}
        title={dataVideo.title}
      />
      <Grid container spacing={3}>
        <Grid item xs={3}>
          <Paper
            elevation={0}
            className={classes.paper}
            onClick={() =>
              handleOpenModal("Cero trámites", "https://vimeo.com/547278397")
            }
          >
            <h3 className={classes.cardTtitle}>Cero trámites</h3>
            <p className={classes.cardDescription}>
              Optimiza tu Plan de Medicina Prepagada con Cero Tramites de
              Saludsa. Accede a la mejor atención médica en un solo lugar, de
              forma rápida y fácil, pagando valores mínimos en consultas,
              exámenes, procedimientos y más.
            </p>
            <div className={classes.playIndicator}>
              <span className={classes.marginRight1}>1:20 </span>
              <PlayCircleOutline color="primary" />
            </div>
          </Paper>
        </Grid>
        <Grid item xs={3}>
          <Paper
            elevation={0}
            className={classes.paper}
            onClick={() =>
              handleOpenModal("Reembolso online", "https://vimeo.com/547278679")
            }
          >
            <h3 className={classes.cardTtitle}>Reembolso online</h3>
            <p className={classes.cardDescription}>
              Conoce sobre nuestro nuevo y mejorado proceso de reembolsos, en
              donde de forma rápida y sencilla podrás solicitar el reembolso de
              tus atenciones médicas desde la comodidad de tu hogar a través de
              tu App Saludsa o Portal Clientes.
            </p>
            <div className={classes.playIndicator}>
              <span className={classes.marginRight1}>1:20 </span>
              <PlayCircleOutline color="primary" />
            </div>
          </Paper>
        </Grid>
        <Grid item xs={3}>
          <Paper
            elevation={0}
            className={classes.paper}
            onClick={() =>
              handleOpenModal(
                "Oficina virtual",
                "https://www.youtube.com/watch?v=X0FRIjj5c0A"
              )
            }
          >
            <h3 className={classes.cardTtitle}>Oficina virtual</h3>
            <p className={classes.cardDescription}>
              Una nueva manera de estar conectados Agenda una video llamada con
              nuestros ejecutivos para que atiendan todos tus requerimientos
            </p>
            <div className={classes.playIndicator}>
              <span className={classes.marginRight1}>1:20 </span>
              <PlayCircleOutline color="primary" />
            </div>
          </Paper>
        </Grid>
        <Grid item xs={3}>
          <Paper
            elevation={0}
            className={classes.paper}
            onClick={() =>
              handleOpenModal(
                "Evaluador de síntomas",
                "https://vimeo.com/547278528"
              )
            }
          >
            <h3 className={classes.cardTtitle}>Evaluador de síntomas</h3>
            <p className={classes.cardDescription}>
              Conoce más sobre el nuevo Evaluador de Síntomas, una herramienta
              de pre diagnóstico precisa y de última tecnología, donde podrás
              evaluar tus síntomas y recibir opciones de atención médica
              inmediata.
            </p>
            <div className={classes.playIndicator}>
              <span className={classes.marginRight1}>1:20 </span>
              <PlayCircleOutline color="primary" />
            </div>
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
};
